import { ExternalLinkIcon, PdfIconV2 } from '../../../assets/svg';
import SuccessIconStageE from '../../../assets/svg/success-icon-stage-e';
import { downloadFile } from '../../../utils/download-file';
import { Helpers } from '../../../utils/helper';

interface MyComponentProps {
  form_name: string;
  form_link: string;
  form_endorsement_date?: string;
  form_signify_status: string;
  formData?: string;
  isSigningRequire: boolean;
  singpassToken?: string;
}
const SignifyDocumentItem: React.FC<MyComponentProps & React.HTMLProps<HTMLDivElement>> = ({
  form_name,
  form_link,
  form_endorsement_date,
  form_signify_status,
  isSigningRequire,
  formData,
  singpassToken,
}: MyComponentProps) => {
  return (
    <>
      <div className='d-flex flex-column gap-1 flex-sm-row justify-content-sm-between'>
        <div>
          <a
            target='_blank'
            onClick={
              !isSigningRequire || (form_signify_status.toLowerCase() === 'signed' && formData)
                ? (event) => {
                    event.preventDefault();
                    downloadFile(formData ?? '', singpassToken, { overrideFileName: form_name });
                  }
                : undefined
            }
            className='polymer-text-links'
            href={form_link}>
            <div>
              <span className='polymer-stage-e_18pt_description d-flex gap-1' style={{ fontWeight: '700' }}>
                {form_name}
                <span>{form_signify_status === 'signed' || !isSigningRequire ? <PdfIconV2 color='#0A676D' /> : <ExternalLinkIcon />}</span>
              </span>
            </div>
          </a>
        </div>
        <div className='align-self-end align-self-sm-center'>
          <span className='d-flex align-items-center justify-content-center gap-1' style={{ color: '#00563A', fontSize: '16px' }}>
            {form_signify_status === 'signed' && <SuccessIconStageE />}
            <span> {Helpers.formatDate(form_endorsement_date)}</span>
          </span>
        </div>
      </div>
    </>
  );
};
export default SignifyDocumentItem;
